import React, { FC } from 'react'
import HeadingAndText from 'components/HeadingAndText'
import Strings from 'project/localisation'
import BlogCarrousel from 'components/blog/BlogCarousel'
import { Query } from '@prismicio/types'
import { TBlogPostResult } from 'common/cms-types' // we need this to make JSX compile

type BlogSectionType = {
  posts: Query<TBlogPostResult>
}

const BlogSection: FC<BlogSectionType> = ({ posts }) => {
  return (
    <>
      <div
        className='d-flex flex-column bg-grey6 px-lg-0 px-6'
        style={{ maxWidth: '100vw' }}
      >
        <HeadingAndText
          title={Strings.newsAndEventsBlog}
          headingSize={3}
          subtitle={Strings.keepUpToDate}
          classesForTitle='fs-fluid-36-80 lh-105'
          subtitleSize='large'
          classesForSubTitle={'px-sm-0 px-8 color-grey5'}
        />
        <BlogCarrousel posts={posts} />
      </div>
    </>
  )
}

export default BlogSection
